import {DateTime} from "luxon";
import {ElementInterface} from "./interfaces/ElementInterface";
import {setDates} from "./helpers/DatesSetter";

export class Element implements ElementInterface{
    createdAt: string;
    id: string;
    isDeleted: boolean;
    isPublished: boolean;
    ownerId: number;
    ownerIds: number[];
    updatedAt?: DateTime = undefined;
    updatedBy: number;
    [key: string]: any;
    schema?: string;

    constructor(data: ElementInterface, schema = '', datesFields: string[] = ['updatedAt']) {
        Object.assign(this, data);
        setDates(this, datesFields);
        if (schema) {
            this.schema = schema;
        }
    }
}
